export default "__VITE_ASSET__CGaiVmWh__"